import { MatDialogConfig } from '@angular/material/dialog';

export const SIZE_CONVERSION_METRIC = 1024;
export const PRESIGNED_URL_FILE_SIZE_THRESHOLD_MB =
  4.99 * SIZE_CONVERSION_METRIC;
export const DEFAULT_DIALOG_CONFIG: MatDialogConfig = {
  width: '450px',
  minHeight: '120px',
};
export const VALID_PATTERN = '^[0-9a-zA-Z_]+$';
export const POSSIBLE_STATIC_OPTIONS = [
  '00000000',
  '00000000-000000',
  'All',
  'CREATE NEW',
];

export const PAGE_OPTIONS = [5, 10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_INDEX = 0;

export const NUMERIC_COLUMN_SUFFIXES = new Set(['_lb', '_ub']);
export const OTHER_COLUMN_SUFFIXES = new Set(['_desc', '_agg']);
export const ALLOWED_COLUMN_SUFFIXES = new Set([
  ...NUMERIC_COLUMN_SUFFIXES,
  ...OTHER_COLUMN_SUFFIXES,
]);
export const VALID_FLOATING_NUMBER_PATTERN = /^-?\d+(\.\d+)?$/;
